import { Container, CardMedia, useTheme } from "@mui/material";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useRegisterAttendance } from "../../classes/api/registerAttendance";
import { useRegisterLiveAttendance } from "../../lives/api/registerLiveAttendance";

const BASE_MEET_URL = "https://meet.cadernovirtual.com.br/room/";

export const WorkAroundAnyMeet = () => {
  const params = useParams();
  const theme = useTheme();
  const registerClassAttendanceMutation = useRegisterAttendance();
  const registerLiveAttendanceMutation = useRegisterLiveAttendance();

  useEffect(() => {
    console.log(params);
    switch (params.type.toLocaleUpperCase()) {
      case "AULA":
        registerClassAttendanceMutation.mutate({ classId: params.id });
        break;
      case "LIVE":
        registerLiveAttendanceMutation.mutate({ liveId: params.id });
        break;
      default:
    }
  }, []);

  return (
    <Container
      sx={{
        p: 2,
        overflow: "auto",
        height: "calc(100dvh - 64px)",

        backgroundColor: theme.palette.menu.background || "#D3D3D3",
      }}
    >
      <CardMedia
        sx={{
          width: "100%",
          height: "90%",
        }}
        component="iframe"
        src={`${BASE_MEET_URL}${params.roomId}`}
        allow={
          "camera " +
          BASE_MEET_URL +
          "; microphone " +
          BASE_MEET_URL +
          "; display-capture " +
          BASE_MEET_URL
        }
      />
    </Container>
  );
};
